

import { useApi } from "hooks"
import { useMutation } from "@tanstack/react-query"
import { RECAPTCHA_TYPES } from "config/constants"

const useConfirm = () => {

  const { apiFetch } = useApi()

  const url = '/auth/confirm/sms';

  const confirm = ({ email, code }) => {
    return apiFetch({
      url,
      method: 'POST',
      data: {
        email,
        code
      },
      captcha: {
        type: RECAPTCHA_TYPES.v3,
        action: 'confirm'
      }
    })
      .then( res => res.data)
  }

  const {
    mutate,
    ...rest
  } = useMutation(confirm)

  return {
    confirm: mutate,
    ...rest
  }

}

export default useConfirm
